import { jsx as l } from "react/jsx-runtime";
import "react";
var o = (r) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.968 5.968C4 7.936 4 11.104 4 17.44v1.12c0 6.336 0 9.504 1.968 11.472S11.104 32 17.44 32h1.12c6.336 0 9.504 0 11.472-1.968S32 24.896 32 18.56v-1.12c0-6.336 0-9.504-1.968-11.472S24.896 4 18.56 4h-1.12C11.104 4 7.936 4 5.968 5.968Zm2.757 6.549c.152 7.28 3.792 11.655 10.173 11.655h.362v-4.165c2.345.233 4.118 1.948 4.83 4.165h3.313c-.91-3.314-3.301-5.145-4.795-5.845 1.494-.864 3.594-2.964 4.095-5.81h-3.01c-.653 2.31-2.59 4.41-4.433 4.608v-4.608h-3.01v8.073c-1.867-.467-4.223-2.73-4.328-8.073H8.725Z",
    clipRule: "evenodd"
  })
});
export {
  o as default
};
